var map = {
	"./asc.svg": "7cd6",
	"./bestellartikel.svg": "b445",
	"./bio.svg": "61a0",
	"./gekuehlt.svg": "bf8c",
	"./msc.svg": "d829",
	"./tiefgekuehlt.svg": "af29",
	"./unsere_kostbarkeiten.svg": "4fef",
	"./wiegeartikel.svg": "d6b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df25";